// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1ybEo","box":"WorkspacesBox_box__luQx-","node":"WorkspacesBox_node__caVEE"};